import React from 'react';
import TeachersInfo from './TeachersInfo';
import './TeachersInfo.css'

const Teachers = () => {

     const teachers = [
          {
               id: 1,
               img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
               name: 'Maruf Bellah',
               job: 'JAVASCRIPT DEVELOPER',
               paragraph: "This center is very beautiful and very comfortable, we had a lot of fun here and the people here are very nice,"
          },
          {
               id: 2,
               img: 'https://images.unsplash.com/photo-1562004760-aceed7bb0fe3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=688&q=80',
               name: 'Alamin Hosain',
               job: 'PYTHON DEVELOPER',
               paragraph: "This center is very beautiful and very comfortable, we had a lot of fun here and the people here are very nice"
          },
          {
               id: 3,
               img: 'https://images.unsplash.com/photo-1555617171-a072c97e09a7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
               name: 'Tarikul Islam',
               job: 'GO DEVELOPER',
               paragraph: "This center is very beautiful and very comfortable, we had a lot of fun here and the people here are very nice"
          },
     ]

     return (
          <div className=''>
               <div class=" my-5 py-5">
                    <div className='media w-50 text-center mx-auto '>
                         <h2 class="text-center pb-4 fw-bold text-primary">THIS IS OUR DEVELOPER</h2>
                         <p>We are all developer, we know how to code and how to teach student that is why we are here for you, so do not wary about your code and your future life , if you want to learn cond and program , you come right place </p>
                    </div>
                    <div class="">
                         <div class="">
                              <div class="card-group  ">
                                   {
                                        teachers.map(teacher => <TeachersInfo
                                             key={teacher.id}
                                             teacher={teacher}

                                        ></TeachersInfo>)
                                   }
                              </div>
                              <div className='text-center'>
                                   <button style={{ fontWeight: 'bold' }} className='btn btn-primary fs-5 '>SEE OUR TEACHER</button>
                              </div>
                         </div>

                    </div>
               </div>








          </div>
     );
};

export default Teachers;